module.exports = __webpack_public_path__ + "img/ydtop.3fca1465.png";